<!-- prettier-ignore -->
<div class="loader">
  <div class="bar-container">
    <div class="bar"></div>
    <div class="bar"></div>
    <div class="bar"></div>
    <div class="bar"></div>
  </div>
  <div class="loader-message" *ngIf="text">{{ text }}</div>
</div>